// src/pages/dashboard/DashboardLayout.tsx
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { selectCurrentOrganization, selectOrganizationLoading, selectShowSetupModal, selectUser } from '../../store/selectors';
import { clearOrganization, fetchUserOrganization, setShowSetupModal } from '../../store/slices/organizationSlice';
import BranchSelectionScreen from './BranchSelectionScreen';
import DashboardNavbar from './components/DashboardNavbar';
import OrganizationSetupModal from './OrganizationSetupModal';
import { clearBranches } from '../../store/slices/branchSlice';
import AccountInactive from './account-inactive/AccountInactive';

const DashboardLayout: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  // const { user, isLoading } = useAuth();
  // const [organizationId, setOrganizationId] = useState<string | null>(null);
  // const [showOrgSetupModal, setShowOrgSetupModal] = useState(false);
  // const [isLoadingData, setIsLoadingData] = useState(true);

  const isLoadingOrganization = useAppSelector(selectOrganizationLoading)
  const organization = useAppSelector(selectCurrentOrganization)
  const organizationId = organization?.id ?? null
  const showOrgSetupModal = useAppSelector(selectShowSetupModal)
  const user = useAppSelector(selectUser)
  const dispatch = useAppDispatch()

  const navigate = useNavigate()

  useEffect(() => {
    // const checkOrganization = async () => {
    //   if (!user) return
    //   setIsLoadingData(true);
    //   getUserOrganization(user?.id).then(data => {
    //     setOrganizationId(data?.id ?? null);
    //     setShowOrgSetupModal(!data?.name);
    //     // console.log('org:', data);

    //   }).catch(error => console.error('Error checking organization:', error))
    //     .finally(() => setIsLoadingData(false))

    // };
    // checkOrganization();

    if (!user) return
    if (!isLoadingOrganization && !organization) {
      dispatch(fetchUserOrganization(user.id)).unwrap().then(result => {
        if (!result) navigate('/login')
      });
    }

    return () => {
      dispatch(clearOrganization())
      dispatch(clearBranches())
    }

  }, [user]);

  const handleOrgSetupComplete = () => {
    // setShowOrgSetupModal(false);
    dispatch(setShowSetupModal(false))
  };

  if (isLoadingOrganization) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!organization?.is_active) {
    return <AccountInactive
      onContactSupport={() => { }}
      onRetryCheck={() => {
        window.location.reload()
      }}
    />
  }

  // If we need to setup the organization first
  if (showOrgSetupModal && organizationId) {
    return <OrganizationSetupModal onComplete={handleOrgSetupComplete} organizationId={organizationId} />;
  }

  // Check if we're on a branch-specific route or the main dashboard
  const isBranchRoute = /^\/dashboard\/[^/]+/.test(location.pathname);
  const isRootDashboard = location.pathname === '/dashboard';

  // console.log(isRootDashboard, organizationId);

  // If we're at the root dashboard, we want to show the branch selection screen
  if (isRootDashboard && organizationId) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col">
        <DashboardNavbar />
        <div className="flex-1">
          <BranchSelectionScreen organizationId={organizationId} />
        </div>
      </div>
    );
  }

  // if (!isLoading && !user)
  //   <Navigate to='/login' />

  // For all other routes, render the Outlet (which will be the appropriate branch pages)
  return <Outlet />;
};

export default DashboardLayout;